module.exports = __webpack_public_path__ + "assets/img/pt-8dd3fc9e.png";